import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, ButtonGroup, Button, Badge, Card, CardHeader, CardFooter, CardBody, CardTitle, CardText } from 'reactstrap';
import { Link } from "react-router-dom";
import { ClassroomListItem } from '../ClassroomListItem/ClassroomListItem';
import StudentListItem from '../StudentListItem/StudentListItem';
import { downloadRollCallPdf } from '../../redux/modules';
import { matchSorter } from 'match-sorter';
import Icon from '@mdi/react';
import {
    mdiAccountArrowRightOutline,
    mdiSquareEditOutline,
    mdiAccountSchoolOutline,
    mdiFileDownloadOutline,
    mdiMenuUpOutline,
    mdiMenuDownOutline,
} from '@mdi/js';
import _ from 'lodash';

import './GroupDetails.css';

export default ({ group, filters }) => {
    const { t }                     = useTranslation();
    const [isOpen, setIsOpen]       = useState(true);

    const dispatch = useDispatch();
    const downloadRollCall = (group) => {
        dispatch(downloadRollCallPdf(group));
    }

    const studentMatchesSearch = student => {
        if (!filters.search)
            return false;

        return matchSorter([student], filters.search, {keys: ['firstname', 'lastname']}).length > 0;
    }

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <Card color="light" className="GroupDetails">
            <CardHeader>
                <CardTitle tag="h3">
                    { group.name }&nbsp;
                    <Badge onClick={() => toggleOpen()} className="pull-right" color={isOpen ? 'info' : 'dark'}>
                        <Icon path={isOpen ? mdiMenuUpOutline : mdiMenuDownOutline} size={1} />&nbsp;
                        <Icon path={mdiAccountSchoolOutline} size={1} />&nbsp;
                        { group.nb_students }&nbsp;
                    </Badge>
                </CardTitle>
            </CardHeader>
            <CardBody style={{
                transition: "all .2s",
                transition: "padding .5s",
                visibility: !isOpen ? "hidden" : "visible",
                height: isOpen ? '100%' : 0,
                padding: isOpen ? 'var(--bs-card-spacer-y) var(--bs-card-spacer-x)' : 0
              }}>
                <CardText tag="div">
                    <CardTitle tag="h4">
                        { t('groups.classrooms') }
                    </CardTitle>
                    <Row className={ `row-cols-sm-1 row-cols-xl-${group.classrooms?.length} `}>
                        { group.classrooms?.length == 0 && (
                            <CardTitle tag="em">
                                { t('groups.has_no_classroom') }
                            </CardTitle>
                        )}
                        { _.sortBy(group.classrooms, 'start_time').map(classroom => (
                        <Col>
                            <ClassroomListItem classroom={ classroom } className="mb-1" condensed />
                        </Col>
                        ))}
                    </Row>
                </CardText>
                <CardText tag="div">
                    <CardTitle tag="h4">
                        { t('groups.students') }
                    </CardTitle>
                    <Row className="row-cols-sm-1 row-cols-lg-2 row-cols-xl-3">
                        { group.students?.length == 0 && (
                            <CardTitle tag="em">
                                { t('groups.has_no_student') }
                            </CardTitle>
                        )}
                        { group.students?.map(student => (
                        <Col>
                            <StudentListItem
                                student={ student }
                                className="mb-1"
                                condensed
                                selected={ studentMatchesSearch(student) }
                                actions={(
                                    <>
                                        <Button tag={Link} to={ `/students/show/${ student.id }` } color="warning" size="sm">
                                            <Icon path={mdiAccountArrowRightOutline} size={1} />
                                        </Button>&nbsp;
                                    </>
                                )}
                            />
                        </Col>
                        ))}
                    </Row>
                </CardText>
            </CardBody>
            <CardFooter>
                <ButtonGroup className="text-right">
                    <Button tag={Link} to={ `/groups/edit/${ group.id }` } color="info">
                        <Icon path={mdiSquareEditOutline} size={1} />&nbsp;
                        { t('groups.edit') }
                    </Button>
                    <Button onClick={ () => downloadRollCall(group) } color="info">
                        <Icon path={mdiFileDownloadOutline} size={1} />&nbsp;
                        { t('groups.download_roll_call_pdf') }
                    </Button>
                </ButtonGroup>
            </CardFooter>
        </Card>
    )
}
